import {subdebug} from '@sanity/cli-core'

export const manifestDebug = subdebug('manifest')
